export default {
  spinner: {
    display: 'flex',
    height: '60vh',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
  },
  tableWrapper: {
    minWidth: 750,
  },
  table: {
    width: '100%',
    fontFamily: 'IranYekanRegular',
    direction: 'ltr',
    overflow: 'hidden',
  },
  tableHeaderColumn: {
    textAlign: 'center',
  },
  tableRowColumn: {
    textAlign: 'center',
  },
  toolbarTitle: { justifyContent: 'flex-start', flexBasis: '60%' },
  toolbarWarning: {
    fontSize: '12px',
    textAlign: 'right',
    color: 'red',
    justifyContent: 'flex-start',
    flexBasis: '60%',
  },
}



// WEBPACK FOOTER //
// ./src/components/common/Services/ServiceStudentsSelector/styles.js